import React from 'react';
import { Link } from 'react-router-dom';
import * as util from "../../../other/util.js";
import ShipCollection from "../../../share/ship-collection.js";

// Provides a list of available ships and inputs for how many to use
export default class FleetSelector extends React.Component {
    render() {
        let available = this.props.available;
        let html = [];
        available.forEach((ship_design) => {
            html.push(this.renderShipDesign(ship_design));
        });

        return (
            <div>
                {html}
            </div>
        )
    }

    renderShipDesign(ship_design) {
        let selected_quantity = this.props.selected.getShipCount(ship_design.design.id);

        return (
            <div key={ship_design.design.id}>
                <util.KeyValueInput
                    label={(<Link className="link-button-menu" to={{ pathname: '/game/ship-design/' + ship_design.design.id, force_update: true }}>{ship_design.design.name}</Link>)}
                    value={selected_quantity}
                    checks={["NUMBER"]}
                    width="40px"
                    maxValue={ship_design.count}
                    postLabel={"/ " + ship_design.count}
                    onChange={(value) => this.handleValueChange(value, ship_design.design)} />
            </div>);
    }

    handleValueChange(value, ship_design) {
        let new_selected = new ShipCollection(this.props.selected);
        new_selected.setShipCount(ship_design, value);
        this.props.onChange(new_selected);
    }
}